import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UpArrow from './UpArrow';
import DownArrow from './DownArrow';

class Accordion extends Component {
  constructor() {
    super();
    this.state = {
      active: null
    };
  }

  onClick(e) {
    let groupId = e.target.getAttribute('data-group-id');
    if (groupId === null) {
      // find id if you clicked on the icon ect
      groupId = e.target.closest('div').getAttribute('data-group-id');
    }
    if (this.state.active === groupId) {
      groupId = null; // reset
    }
    this.setState({ active: groupId });
  }

  renderGrouping(isActive, groupId, contents, onClick, title) {
    return (
      <div
        className={`accordion__group ${ isActive ? 'active' : '' }`}
      >
        <a
          className="accordion__header"
          data-group-id={groupId}
          // eslint-disable-next-line
          href="javascript:;"
          onClick={onClick}
          title={title}
        >
          <div
            className="accordion__header-title"
            data-group-id={groupId}
          >
            {title}
          </div>
          <div
            className={`accordion__header-arrow ${isActive ? 'down' : 'up'}`}
            data-group-id={groupId}
          >
            {
              isActive ?
                <UpArrow data-group-id={groupId} /> :
                <DownArrow  data-group-id={groupId} />
            }
          </div>
        </a>
        <div className="accordion__content">
          {contents.map((content, idx) =>
            <div
              className="accordion__content-info"
              key={`${groupId}-${idx}`}
            >
              {content.info || content}
            </div>
        )}
        </div>
      </div>
    );
  }

  render() {
    const { groups } = this.props;
    const boundOnClick = this.onClick.bind(this);
    const activeGroup = +this.state.active;
    return (
      <section className="accordion">
        {groups.map((group, idx) => {
          return (
            <span key={idx}>
              {
                this.renderGrouping(
                  (activeGroup === idx + 1),
                  (idx + 1),
                  group.contents,
                  boundOnClick,
                  group.title
                )
              }
           </span>
          );
        })}
      </section>
    );
  }
}

Accordion.propTypes = {
  groups: PropTypes.array
};

export default Accordion;
